import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { RouteConstants } from '@core/constants/route.constants';
import { AuthenticationService } from '@core/services/authentication.service';
import { environment } from 'environments/environment';


@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {

  constructor(
    private router: Router,
    private authenticationService: AuthenticationService
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (environment.maintenanceMode) {
      this.router.navigate(["/maintenance"]);
      return false;
    }

    const currentUser = this.authenticationService.currentUser;
    if (currentUser) {
      // logged in so return true
      return true;
    }

    if (`/${route.url[0].path}` !== RouteConstants.LOGIN_MODULE.LOGIN) {
      // not logged in so redirect to login page with the return url
      this.router.navigate([RouteConstants.LOGIN_MODULE.LOGIN], { queryParams: { returnUrl: state.url } });
      return false;
    }
    return true;

  }
}
